__turbopack_context__.v({
  "tableContainer": "IndicatorTable-timeline-module__GekLwW__tableContainer",
});
